import { useMatches, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useDocumentTitlePrefix } from '../../state/notifications/browser-title';
import { getDocumentTitle } from '../../services/routing/routeMetadata';

const BrowserDocumentTitle = ({ title }: { title: string }) => {
  const prefix = useDocumentTitlePrefix();

  useEffect(() => {
    document.title = prefix ? `${prefix} ${title}` : title;
  }, [prefix, title]);

  return null;
};

const RouteDocumentTitle = ({ useTitlePrefix }: { useTitlePrefix: () => string }) => {
  const titlePrefix = useTitlePrefix();
  return <BrowserDocumentTitle title={getDocumentTitle(titlePrefix)} />;
};

export const DocumentTitle = () => {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const titleMatch = useMatches({
    select: (matches) => {
      const match = [...matches].reverse().find(({ staticData }) => staticData.useDocumentTitlePrefix);
      return match?.staticData.useDocumentTitlePrefix ? { key: match.id, useTitlePrefix: match.staticData.useDocumentTitlePrefix } : undefined;
    },
  });

  if (titleMatch) {
    return <RouteDocumentTitle key={titleMatch.key} useTitlePrefix={titleMatch.useTitlePrefix} />;
  }
  return <BrowserDocumentTitle title={pathname === '/' ? 'Meisterplan Dev Platform' : getDocumentTitle('Page not found')} />;
};
